<script>
import { eventsFiltersPresets } from '@/utils/constants'
import calendarIcon from '@/assets/images/icons/calendar.svg?inline'
import SearchResultsControls from '@/components/views/filters/SearchResultsControls.vue'
import EventsTable from '@/components/events/views/Table.vue'
import EventsFilters from '@/components/events/views/Filters.vue'
import EventsEditForm from '@/components/events/views/EditForm.vue'
import EventsParticipationForm from '@/components/events/views/ParticipationForm.vue'
import EventsProgram from '@/components/events/ui/Program.vue'
import infiniteScroll from '@/components/views/infiniteScroll/infiniteScroll.vue'

export default {
  name: 'events',
  components: {
    calendarIcon,
    SearchResultsControls,
    EventsTable,
    EventsFilters,
    EventsEditForm,
    EventsParticipationForm,
    EventsProgram,
    infiniteScroll
  },
  metaInfo: {
    title: 'Вебинары и мероприятия'
  },
  data: () => ({
    eventsFiltersPresets
  }),
  computed: {
    isEditModalActive() {
      return this.$store.getters['events/getEditFormModal'].active
    },
    isParticipationModalActive() {
      return this.$store.getters['events/getParticipationFormModal'].active
    },
    isProgramModalActive() {
      return this.$store.getters['events/getProgramModal'].active
    },
    isLoading() {
      return this.$store.getters['events/isLoading']
    },
    isLoadingMore() {
      return this.$store.getters['events/isLoadingMore']
    },
    isLoadingMoreBlocked() {
      return this.$store.getters['events/isLoadingMoreBlocked']
    },
    isControls() {
      return this.$store.getters['events/isControls']
    },
    pagination() {
      return this.$store.getters['events/getPagination']
    },
    isCollectionEmpty() {
      return !this.isLoading && !this.$store.getters['events/getCollection'].length
    },
    hasError() {
      return this.$store.getters['events/hasError']
    },
    form() {
      return this.$store.getters['events/getSearchForm']
    }
  },
  created() {
    this.search()

    this.$store.dispatch('getDictionary', {
      params: {},
      config: {
        dictionaryName: 'eventsTypes',
        target: 'events.dictionaries.eventsTypes'
      }
    })
  },
  beforeDestroy() {
    this.$store.commit('events/setInitialState')
  },
  methods: {
    closeEditModal() {
      this.$store.commit('events/updateEditFormModal', {
        active: false
      })

      this.$store.commit('events/clearEditForm')
    },
    closeParticipationModal() {
      this.$store.commit('events/updateParticipationFormModal', {
        active: false,
        header: null,
      })

      this.$store.commit('events/clearParticipationForm')
    },
    closeProgramModal() {
      this.$store.commit('events/updateProgramModal', {
        active: false,
        header: null,
        content: null,
      })

      this.$store.commit('events/clearEditForm')
    },
    loadMore() {
      this.$store.commit('events/setIsLoadingMore', true)
      this.$store.dispatch('events/getCollection', {
        ...this.form,
        page: this.pagination + 1
      })
    },
    search() {
      this.$store.commit('events/setIsLoading', true)
      this.$store.commit('events/setCollection', [])

      this.$store.dispatch('events/getCollection', {
        ...this.form,
        page: 1,
        perPage: 10
      })
    }
  }
}
</script>

<template>
  <div class="events">
    <h1 class="rex-title rex-title--with-icon">
      <calendar-icon
        fill="#ff4368"
      />
      Мероприятия и рекламные туры
    </h1>
    <div class="rex-wrap">
      <div>
        <search-results-controls
          v-if="isControls"
          store-module="events"
          getter-name="getField"
          setter-name="setField"
          target-sorting-order="form.dateSort"
          target-preset="activePreset"
          preset-setter="setFiltersPreset"
          :sort-order-keys="['ascending', 'descending']"
          :presets="eventsFiltersPresets"
          :is-sort-fields-select="false"
          sort-field-name="По дате"
          @sortOrderChanged="search"
          @presetChanged="search"
        />
        <div
          v-if="hasError"
          class="search-content__no-results"
        >
          <h2>
            Произошла ошибка при запросе списка мероприятий<br>
            Перезагрузите страницу или попробуйте позже
          </h2>
        </div>
        <div
          v-if="isCollectionEmpty && !hasError"
          class="search-content__no-results"
        >
          <h2>
            Ничего не найдено<br>
            Попробуйте изменить настройки фильтров
          </h2>
        </div>
        <infinite-scroll
          v-if="!isCollectionEmpty && !hasError"
          :pagination="pagination"
          :is-loading="isLoading || isLoadingMore"
          :is-loading-blocked="isLoadingMoreBlocked"
          @loadMore="loadMore"
        >
          <events-table
            v-if="!isLoading"
          />
        </infinite-scroll>
      </div>
      <div>
        <events-filters />
      </div>
    </div>
    <b-modal
      :active="isEditModalActive"
      scroll="keep"
      :can-cancel="['outside']"
      :width="800"
      @close="closeEditModal"
    >
      <events-edit-form />
    </b-modal>
    <b-modal
      :active="isParticipationModalActive"
      scroll="keep"
      :can-cancel="['outside']"
      :width="420"
      @close="closeParticipationModal"
    >
      <events-participation-form />
    </b-modal>
    <b-modal
      :active="isProgramModalActive"
      scroll="keep"
      :can-cancel="['outside']"
      :width="520"
      @close="closeProgramModal"
    >
      <events-program />
    </b-modal>
  </div>
</template>